// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import moment from 'moment';
import { DATE_TIME_FORMAT } from '../../shared/constants/input.constants';
import { VideoCall } from '../../shared/model/video-call.model';
import { VideoCallService } from './video-call.service';
import { SessionService } from '../session/session.service';
import * as i0 from "@angular/core";
import * as i1 from "./video-call.service";
import * as i2 from "../session/session.service";
import * as i3 from "@angular/router";
import * as i4 from "@angular/forms";
import * as i5 from "../../ng-jhipster/language/jhi-translate.directive";
import * as i6 from "../../shared/alert/alert-error.component";
import * as i7 from "@angular/common";
import * as i8 from "@fortawesome/angular-fontawesome";
function VideoCallUpdateComponent_option_54_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const sessionOption_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngValue", sessionOption_r1.id === (ctx_r0.editForm.get("session").value == null ? null : ctx_r0.editForm.get("session").value.id) ? ctx_r0.editForm.get("session").value : sessionOption_r1);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(sessionOption_r1.id);
} }
export class VideoCallUpdateComponent {
    constructor(videoCallService, sessionService, activatedRoute, fb) {
        this.videoCallService = videoCallService;
        this.sessionService = sessionService;
        this.activatedRoute = activatedRoute;
        this.fb = fb;
        this.isSaving = false;
        this.sessions = [];
        this.editForm = this.fb.group({
            id: [],
            externalId: [],
            externalSessionKey: [],
            startTime: [],
            endTime: [],
            status: [],
            duration: [],
            participantsCount: [],
            hasVideo: [],
            hasVoip: [],
            session: [],
        });
    }
    ngOnInit() {
        this.activatedRoute.data.subscribe(({ videoCall }) => {
            if (!videoCall.id) {
                const today = moment().startOf('day');
                videoCall.startTime = today;
                videoCall.endTime = today;
            }
            this.updateForm(videoCall);
            this.sessionService.query().subscribe((res) => (this.sessions = res.body || []));
        });
    }
    updateForm(videoCall) {
        this.editForm.patchValue({
            id: videoCall.id,
            externalId: videoCall.externalId,
            externalSessionKey: videoCall.externalSessionKey,
            startTime: videoCall.startTime ? videoCall.startTime.format(DATE_TIME_FORMAT) : null,
            endTime: videoCall.endTime ? videoCall.endTime.format(DATE_TIME_FORMAT) : null,
            status: videoCall.status,
            duration: videoCall.duration,
            participantsCount: videoCall.participantsCount,
            hasVideo: videoCall.hasVideo,
            hasVoip: videoCall.hasVoip,
            session: videoCall.session,
        });
    }
    previousState() {
        window.history.back();
    }
    save() {
        this.isSaving = true;
        const videoCall = this.createFromForm();
        if (videoCall.id !== undefined) {
            this.subscribeToSaveResponse(this.videoCallService.update(videoCall));
        }
        else {
            this.subscribeToSaveResponse(this.videoCallService.create(videoCall));
        }
    }
    createFromForm() {
        return Object.assign(Object.assign({}, new VideoCall()), { id: this.editForm.get(['id']).value, externalId: this.editForm.get(['externalId']).value, externalSessionKey: this.editForm.get(['externalSessionKey']).value, startTime: this.editForm.get(['startTime']).value ? moment(this.editForm.get(['startTime']).value, DATE_TIME_FORMAT) : undefined, endTime: this.editForm.get(['endTime']).value ? moment(this.editForm.get(['endTime']).value, DATE_TIME_FORMAT) : undefined, status: this.editForm.get(['status']).value, duration: this.editForm.get(['duration']).value, participantsCount: this.editForm.get(['participantsCount']).value, hasVideo: this.editForm.get(['hasVideo']).value, hasVoip: this.editForm.get(['hasVoip']).value, session: this.editForm.get(['session']).value });
    }
    subscribeToSaveResponse(result) {
        result.subscribe(() => this.onSaveSuccess(), () => this.onSaveError());
    }
    onSaveSuccess() {
        this.isSaving = false;
        this.previousState();
    }
    onSaveError() {
        this.isSaving = false;
    }
    trackById(index, item) {
        return item.id;
    }
}
VideoCallUpdateComponent.ɵfac = function VideoCallUpdateComponent_Factory(t) { return new (t || VideoCallUpdateComponent)(i0.ɵɵdirectiveInject(i1.VideoCallService), i0.ɵɵdirectiveInject(i2.SessionService), i0.ɵɵdirectiveInject(i3.ActivatedRoute), i0.ɵɵdirectiveInject(i4.FormBuilder)); };
VideoCallUpdateComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: VideoCallUpdateComponent, selectors: [["jhi-video-call-update"]], decls: 66, vars: 6, consts: [[1, "row", "justify-content-center"], [1, "col-8"], ["name", "editForm", "role", "form", "novalidate", "", 3, "formGroup", "ngSubmit"], ["id", "jhi-video-call-heading", "jhiTranslate", "inukaNgApp.videoCall.home.createOrEditLabel"], [1, "form-group", 3, "hidden"], ["for", "id", "jhiTranslate", "global.field.id"], ["type", "text", "id", "id", "name", "id", "formControlName", "id", "readonly", "", 1, "form-control"], [1, "form-group"], ["jhiTranslate", "inukaNgApp.videoCall.externalId", "for", "field_externalId", 1, "form-control-label"], ["type", "text", "name", "externalId", "id", "field_externalId", "formControlName", "externalId", 1, "form-control"], ["jhiTranslate", "inukaNgApp.videoCall.externalSessionKey", "for", "field_externalSessionKey", 1, "form-control-label"], ["type", "text", "name", "externalSessionKey", "id", "field_externalSessionKey", "formControlName", "externalSessionKey", 1, "form-control"], ["jhiTranslate", "inukaNgApp.videoCall.startTime", "for", "field_startTime", 1, "form-control-label"], [1, "d-flex"], ["id", "field_startTime", "type", "datetime-local", "name", "startTime", "formControlName", "startTime", "placeholder", "YYYY-MM-DD HH:mm", 1, "form-control"], ["jhiTranslate", "inukaNgApp.videoCall.endTime", "for", "field_endTime", 1, "form-control-label"], ["id", "field_endTime", "type", "datetime-local", "name", "endTime", "formControlName", "endTime", "placeholder", "YYYY-MM-DD HH:mm", 1, "form-control"], ["jhiTranslate", "inukaNgApp.videoCall.status", "for", "field_status", 1, "form-control-label"], ["type", "text", "name", "status", "id", "field_status", "formControlName", "status", 1, "form-control"], ["jhiTranslate", "inukaNgApp.videoCall.duration", "for", "field_duration", 1, "form-control-label"], ["type", "number", "name", "duration", "id", "field_duration", "formControlName", "duration", 1, "form-control"], ["jhiTranslate", "inukaNgApp.videoCall.participantsCount", "for", "field_participantsCount", 1, "form-control-label"], ["type", "number", "name", "participantsCount", "id", "field_participantsCount", "formControlName", "participantsCount", 1, "form-control"], ["jhiTranslate", "inukaNgApp.videoCall.hasVideo", "for", "field_hasVideo", 1, "form-control-label"], ["type", "checkbox", "name", "hasVideo", "id", "field_hasVideo", "formControlName", "hasVideo", 1, "form-control"], ["jhiTranslate", "inukaNgApp.videoCall.hasVoip", "for", "field_hasVoip", 1, "form-control-label"], ["type", "checkbox", "name", "hasVoip", "id", "field_hasVoip", "formControlName", "hasVoip", 1, "form-control"], ["jhiTranslate", "inukaNgApp.videoCall.session", "for", "field_session", 1, "form-control-label"], ["id", "field_session", "name", "session", "formControlName", "session", 1, "form-control"], [3, "ngValue"], [3, "ngValue", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["type", "button", "id", "cancel-save", 1, "btn", "btn-secondary", 3, "click"], ["icon", "ban"], ["jhiTranslate", "entity.action.cancel"], ["type", "submit", "id", "save-entity", 1, "btn", "btn-primary", 3, "disabled"], ["icon", "save"], ["jhiTranslate", "entity.action.save"]], template: function VideoCallUpdateComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "form", 2);
        i0.ɵɵlistener("ngSubmit", function VideoCallUpdateComponent_Template_form_ngSubmit_2_listener() { return ctx.save(); });
        i0.ɵɵelementStart(3, "h2", 3);
        i0.ɵɵtext(4, "Create or edit a Video Call");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div");
        i0.ɵɵelement(6, "jhi-alert-error");
        i0.ɵɵelementStart(7, "div", 4);
        i0.ɵɵelementStart(8, "label", 5);
        i0.ɵɵtext(9, "ID");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(10, "input", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 7);
        i0.ɵɵelementStart(12, "label", 8);
        i0.ɵɵtext(13, "External Id");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(14, "input", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "div", 7);
        i0.ɵɵelementStart(16, "label", 10);
        i0.ɵɵtext(17, "External Session Key");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(18, "input", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "div", 7);
        i0.ɵɵelementStart(20, "label", 12);
        i0.ɵɵtext(21, "Start Time");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "div", 13);
        i0.ɵɵelement(23, "input", 14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(24, "div", 7);
        i0.ɵɵelementStart(25, "label", 15);
        i0.ɵɵtext(26, "End Time");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(27, "div", 13);
        i0.ɵɵelement(28, "input", 16);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(29, "div", 7);
        i0.ɵɵelementStart(30, "label", 17);
        i0.ɵɵtext(31, "Status");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(32, "input", 18);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(33, "div", 7);
        i0.ɵɵelementStart(34, "label", 19);
        i0.ɵɵtext(35, "Duration");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(36, "input", 20);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(37, "div", 7);
        i0.ɵɵelementStart(38, "label", 21);
        i0.ɵɵtext(39, "Participants Count");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(40, "input", 22);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(41, "div", 7);
        i0.ɵɵelementStart(42, "label", 23);
        i0.ɵɵtext(43, "Has Video");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(44, "input", 24);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(45, "div", 7);
        i0.ɵɵelementStart(46, "label", 25);
        i0.ɵɵtext(47, "Has Voip");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(48, "input", 26);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(49, "div", 7);
        i0.ɵɵelementStart(50, "label", 27);
        i0.ɵɵtext(51, "Session");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(52, "select", 28);
        i0.ɵɵelement(53, "option", 29);
        i0.ɵɵtemplate(54, VideoCallUpdateComponent_option_54_Template, 2, 2, "option", 30);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(55, "div");
        i0.ɵɵelementStart(56, "button", 31);
        i0.ɵɵlistener("click", function VideoCallUpdateComponent_Template_button_click_56_listener() { return ctx.previousState(); });
        i0.ɵɵelement(57, "fa-icon", 32);
        i0.ɵɵtext(58, "\u00A0");
        i0.ɵɵelementStart(59, "span", 33);
        i0.ɵɵtext(60, "Cancel");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(61, "button", 34);
        i0.ɵɵelement(62, "fa-icon", 35);
        i0.ɵɵtext(63, "\u00A0");
        i0.ɵɵelementStart(64, "span", 36);
        i0.ɵɵtext(65, "Save");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("formGroup", ctx.editForm);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("hidden", !ctx.editForm.get("id").value);
        i0.ɵɵadvance(46);
        i0.ɵɵproperty("ngValue", null);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.sessions)("ngForTrackBy", ctx.trackById);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("disabled", ctx.editForm.invalid || ctx.isSaving);
    } }, directives: [i4.ɵNgNoValidate, i4.NgControlStatusGroup, i4.FormGroupDirective, i5.JhiTranslateDirective, i6.AlertErrorComponent, i4.DefaultValueAccessor, i4.NgControlStatus, i4.FormControlName, i4.NumberValueAccessor, i4.CheckboxControlValueAccessor, i4.SelectControlValueAccessor, i4.NgSelectOption, i4.ɵNgSelectMultipleOption, i7.NgForOf, i8.FaIconComponent], encapsulation: 2 });
